export var AuthErrorCode;
(function (AuthErrorCode) {
    AuthErrorCode["NoSessionError"] = "NO_SESSION_ERROR";
    AuthErrorCode["ExchangeTokenInvalidException"] = "INVALID_EXCHANGE_TOKEN";
    AuthErrorCode["InvalidTokenSignatureException"] = "INVALID_TOKEN_SIGNATURE";
    AuthErrorCode["SessionMismatchException"] = "SESSION_MISMATCH_EXCEPTION";
    AuthErrorCode["JwtExpired"] = "JWT_EXPIRED";
})(AuthErrorCode || (AuthErrorCode = {}));
//# sourceMappingURL=auth-error-code.js.map